import { cn } from "@/lib/utils";

type FileIconProps = {
  className?: string;
};

/** Untitled UI solid file icon (document). */
export function DocumentFileIcon({ className }: FileIconProps) {
  return (
    <span className={cn("inline-flex size-8 shrink-0 text-violet-700 dark:text-violet-600", className)}>
      <svg fill="none" viewBox="0 0 40 40" aria-hidden className="size-full"><path fill="currentColor" d="M4 4a4 4 0 0 1 4-4h16l12 12v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z" /><path fill="#fff" d="m24 0 12 12h-8a4 4 0 0 1-4-4z" opacity=".3" /><path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12.8 20h14.4m-14.4 3.2h14.4m-14.4 3.2h14.4m-14.4 3.2H24" /></svg>
    </span>
  );
}
